import api from './api'

/** Redes estáticas no peer (RouterOS / host), tabela static_networks. */
export const staticNetworksApi = {
  getByRouter: async (routerId) => {
    const response = await api.get(`/routers/${routerId}/static-networks`)
    return response.data
  },

  getByHost: async (hostId) => {
    const response = await api.get(`/hosts/${hostId}/static-networks`)
    return response.data
  },

  getById: async (routerId, staticNetworkId) => {
    const response = await api.get(`/routers/${routerId}/static-networks/${staticNetworkId}`)
    return response.data
  },

  create: async (routerId, data) => {
    const response = await api.post(`/routers/${routerId}/static-networks`, data)
    return response.data
  },

  createForHost: async (hostId, data) => {
    const response = await api.post(`/hosts/${hostId}/static-networks`, data)
    return response.data
  },

  update: async (routerId, staticNetworkId, data) => {
    const response = await api.put(`/routers/${routerId}/static-networks/${staticNetworkId}`, data)
    return response.data
  },

  delete: async (routerId, staticNetworkId) => {
    await api.delete(`/routers/${routerId}/static-networks/${staticNetworkId}`)
  },

  deleteForHost: async (hostId, staticNetworkId) => {
    await api.delete(`/hosts/${hostId}/static-networks/${staticNetworkId}`)
  },

  deleteGeneric: async (deviceType, deviceId, staticNetworkId) => {
    const prefix = deviceType === 'host' ? 'hosts' : 'routers'
    await api.delete(`/${prefix}/${deviceId}/static-networks/${staticNetworkId}`)
  },

  createGeneric: async (deviceType, deviceId, data) => {
    const prefix = deviceType === 'host' ? 'hosts' : 'routers'
    const response = await api.post(`/${prefix}/${deviceId}/static-networks`, data)
    return response.data
  },

  batchUpdateStatus: async (routerId, data) => {
    const response = await api.post(`/routers/${routerId}/static-networks/batch-status`, data)
    return response.data
  },

  applyPending: async (routerId) => {
    const response = await api.post(`/routers/${routerId}/static-networks/apply`)
    return response.data
  },

  applyPendingHost: async (hostId) => {
    const response = await api.post(`/hosts/${hostId}/static-networks/apply`)
    return response.data
  },

  applyPendingGeneric: async (deviceType, deviceId) => {
    const prefix = deviceType === 'host' ? 'hosts' : 'routers'
    const response = await api.post(`/${prefix}/${deviceId}/static-networks/apply`)
    return response.data
  },

  getVpnTunnelInterfaces: async (routerId) => {
    const response = await api.get(`/routers/${routerId}/static-networks/vpn-tunnel-interfaces`)
    return response.data
  },
}
